<template>
  <component
    :is="tag"
    v-bind="binds"
    class="winners-2021-place-winners-card-prize"
  >
    <div class="winners-2021-place-winners-card-prize__preview">
      <img
        src="@/assets/img/prizes/2021/preview-bg.png"
        alt=""
        class="winners-2021-place-winners-card-prize__bg"
      />
      <img
        :src="prize.preview"
        :alt="prize.name"
        class="winners-2021-place-winners-card-prize__img"
      />
    </div>
  </component>
</template>

<script>
export default {
  name: "Winners2021PlaceWinnersCardPrize",
  props: {
    /** @type {<{preview: string, href?: string}>} */
    prize: {
      type: Object,
      required: true
    }
  },
  computed: {
    tag() {
      return this.prize.href ? "a" : "div";
    },
    binds() {
      return this.prize.href
        ? { href: this.prize.href, target: "_blank", rel: "noopener" }
        : null;
    }
  }
};
</script>

<style lang="scss">
.winners-2021-place-winners-card-prize {
  $p: &;

  text-align: center;
  width: 115px;

  &__preview {
    margin-bottom: 15px;
    width: 100%;
    height: 100px;
    position: relative;
  }

  &__img,
  &__bg {
    position: absolute;
    pointer-events: none;
  }

  &__bg {
    width: 180px;
    height: 136px;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
  }

  &__img {
    max-width: 100px;
    max-height: 115px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    transition: transform 0.2s;
  }

  &:hover {
    #{$p}__img {
      transform: translate(-50%, -50%) scale(1.1);
    }
  }
}
</style>
